exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!swagger-ui/dist/swagger-ui.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n\n.swagger-container {\n  max-width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/morne/Documents/dev/remindworks-docs/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/morne/Documents/dev/remindworks-docs/node_modules/postcss-loader?{"ident":"postcss"}!/Users/morne/Documents/dev/remindworks-docs/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles